import type { NodeDefinition } from "../domain/types/index.js";

type NodeSpec = Omit<NodeDefinition, "id"> & { id?: never };

function node(id: NodeDefinition["id"], spec: NodeSpec): NodeDefinition {
  return { id, ...spec };
}

// 進行は next のみ。x/y は描画位置。列数や隣接の制約はない。
export const MAP_NODES = {
  start: node("start", { kind: "start", next: ["a1-maint"], x: 1, y: 0 }),

  "a1-maint": node("a1-maint", { kind: "case", caseId: "a1-maint", next: ["a2-add"], x: 1, y: 1 }),
  "a2-add": node("a2-add", { kind: "case", caseId: "a2-add", next: ["a3-link", "rest-1"], x: 1, y: 2 }),
  "a3-link": node("a3-link", { kind: "case", caseId: "a3-link", next: ["a3-inquiry"], x: 0, y: 3 }),
  "rest-1": node("rest-1", { kind: "rest", next: ["a3-inquiry"], x: 2, y: 3 }),
  "a3-inquiry": node("a3-inquiry", { kind: "case", caseId: "a3-inquiry", next: ["a4-infra", "a4-expand"], x: 1, y: 4 }),
  "a4-infra": node("a4-infra", { kind: "case", caseId: "a4-infra", next: ["rest-1b"], x: 0, y: 5 }),
  "a4-expand": node("a4-expand", { kind: "case", caseId: "a4-expand", next: ["rest-1b"], x: 2, y: 5 }),
  "rest-1b": node("rest-1b", { kind: "rest", next: ["b1-client", "b1-parallel"], x: 1, y: 6 }),

  "b1-client": node("b1-client", { kind: "case", caseId: "b1-client", next: ["b2-ops"], x: 0, y: 7 }),
  "b1-parallel": node("b1-parallel", { kind: "case", caseId: "b1-parallel", next: ["b2-ops", "rest-2"], x: 2, y: 7 }),
  "b2-ops": node("b2-ops", { kind: "case", caseId: "b2-ops", next: ["rest-2b"], x: 1, y: 8 }),
  "rest-2": node("rest-2", { kind: "rest", next: ["rest-2b"], x: 2, y: 8 }),
  "rest-2b": node("rest-2b", { kind: "rest", next: ["b4-large", "b4-platform"], x: 1, y: 9 }),
  "b4-large": node("b4-large", { kind: "case", caseId: "b4-large", next: ["rest-2c"], x: 0, y: 10 }),
  "b4-platform": node("b4-platform", { kind: "case", caseId: "b4-platform", next: ["rest-2c"], x: 2, y: 10 }),
  "rest-2c": node("rest-2c", { kind: "rest", next: ["c1-overhaul", "c2-debt"], x: 1, y: 11 }),

  "c1-overhaul": node("c1-overhaul", { kind: "case", caseId: "c1-overhaul", next: ["c2-demand"], x: 0, y: 12 }),
  "c2-debt": node("c2-debt", { kind: "case", caseId: "c2-debt", next: ["c1-emergency"], x: 2, y: 12 }),
  "c2-demand": node("c2-demand", { kind: "case", caseId: "c2-demand", next: ["rest-3"], x: 0, y: 13 }),
  "c1-emergency": node("c1-emergency", { kind: "case", caseId: "c1-emergency", next: ["rest-3"], x: 2, y: 13 }),
  "rest-3": node("rest-3", { kind: "rest", next: ["c3-release", "c3-incident"], x: 1, y: 14 }),
  "c3-release": node("c3-release", { kind: "case", caseId: "c3-release", next: ["c4-strategy"], x: 0, y: 15 }),
  "c3-incident": node("c3-incident", { kind: "case", caseId: "c3-incident", next: ["c4-final"], x: 2, y: 15 }),
  "c4-strategy": node("c4-strategy", { kind: "case", caseId: "c4-strategy", next: ["rest-3b"], x: 0, y: 16 }),
  "c4-final": node("c4-final", { kind: "case", caseId: "c4-final", next: ["c5-preboss-b"], x: 2, y: 16 }),
  "rest-3b": node("rest-3b", { kind: "rest", next: ["rest-3c"], x: 0, y: 17 }),
  "c5-preboss-b": node("c5-preboss-b", { kind: "case", caseId: "c5-preboss-b", next: ["rest-3c"], x: 2, y: 17 }),
  "rest-3c": node("rest-3c", { kind: "rest", next: ["boss"], x: 1, y: 18 }),
  boss: node("boss", { kind: "case", caseId: "standard-boss", next: [], x: 1, y: 19 }),
} as const satisfies Record<string, NodeDefinition>;
